import { useMemo } from "react";
import { keyBy } from "lodash";
import { useForm } from "@xvii/useform";
import { useDialogActions } from "cityads-v3/hooks/dialog";
import { useEntities } from "cityads-v3/hooks/entities";
import { BannerRotatorList } from "cityads-v3/types/bannerRotator";
import { useTranslation } from "react-i18next";


export function useGetCode() {
  const { t } = useTranslation(['BannerRotator'])
  const [bannerRotator] = useEntities<BannerRotatorList>('bannerRotatorTool');
  const bannerRotatorById = useMemo(() => keyBy(bannerRotator?.bannerRotator, 'id'), [bannerRotator?.bannerRotator])

  const form = useForm({
    fields: {
      type: { defaultValue: 'async_embed_code', valueType: String() },
    }
  })

  const typeList = [
    {
      value: 'async_embed_code',
      name: t('async_embed_code')
    },

    /**
     * https://cad.tpondemand.com/entity/76002-rotator-ubrat-iz-formatov-koda-javascript
     */
    /* {
      value: 'embed_code',
      name: t('embed_code')
    } */
  ]

  return {
    form,
    typeList,
    dialog: useDialogActions(),
    bannerRotatorById,
  }
}
